export default __webpack_public_path__ + "static/media/personal9.5de816e2.jpeg";